import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";
import { USER_ROLES } from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";

export const getNotificationPreferences = async ({ account }) => {
  if (!account) return;

  let notificationPreferences = {};

  const userRole = getCurrentUserRole();

  if ([USER_ROLES.ADMIN, USER_ROLES.USER].includes(userRole)) {
    const url = interpolate(endpoints.notification.preferenceByAccount, {
      account,
    });

    const { data } = await api.get(url);
    notificationPreferences = data;
  }

  return notificationPreferences;
};

export const updateNotificationPreferences = async (payload) => {
  return await api.put(endpoints.notification.preference, payload);
};
